export default __webpack_public_path__ + "static/media/246.c0b0373e.png";